import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './UserContext';
import { PostHogProvider } from 'posthog-js/react';

const options = {
    api_host: 'https://us.i.posthog.com',
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        {/*}
        <PostHogProvider 
            apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_API_KEY} 
            options={options}>
            */}
            <AuthProvider>
                <App />
            </AuthProvider>
            {/*
        </PostHogProvider>
        */}
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
